'use strict';

import ErrorType from '../constants/error-type';

var Sizzle = require('sizzle');
var VideoConfig = require('../config');
var Device = require('../util/device');
var Debug = require('../util/debug')('android-fallback');
var VideoAttributes = require('../util/video-attributes');
var VideoDataBuilder = require('../util/video-data-builder');
var Stats = require('../util/stats');

const DEFAULT_CONFIG = {
    packageName: 'se.svt.android.svtplay',
    baseUrl: 'www.svtplay.se/app/android?play=',
    androidFallbackBaseUrl: 'http://api.svt.se/videoplayer-embed/android/',
    androidFallbackInstallUrl: 'http://api.svt.se/videoplayer-embed/android/install'
};

const BOLIBOMPA_CONFIG = {
    packageName: 'se.svt.bolibompa',
    baseUrl: 'www.svt.se/barnkanalen/bolibompa/android-update.html?play='
};

const BARN_CONFIG = {
    packageName: 'svt.se.barnkanalen',
    androidFallbackBaseUrl: 'https://www.svt.se/barnkanalen/barnplay/app-download/',
    androidFallbackInstallUrl: 'https://www.svt.se/barnkanalen/barnplay/app-download/'
};


module.exports = {
    create: function (api) {
        function _sendEvent(eventType, data) {
            api.fire(eventType, data);
        }

        function _buildExternalDeviceUrlForAndroid(videoData) {
            const client = Stats.getClient();

            let config;
            if (VideoConfig.androidFallback) {
                config = Object.assign({}, DEFAULT_CONFIG, VideoConfig.androidFallback);
            } else if (client === 'bolibompa') {
                config = Object.assign({}, DEFAULT_CONFIG, BOLIBOMPA_CONFIG);
            } else if (client === 'barnplay' || client === 'barnkanalen') {
                config = Object.assign({}, DEFAULT_CONFIG, BARN_CONFIG);
            } else {
                config = Object.assign({}, DEFAULT_CONFIG);
            }

            const { packageName, baseUrl, androidFallbackBaseUrl, androidFallbackInstallUrl } = config;

            const playVideoDataFallbackUrl = androidFallbackBaseUrl + 'videodata/?json=' + encodeURIComponent(JSON.stringify(videoData));
            let url = baseUrl + encodeURIComponent(playVideoDataFallbackUrl);

            if (Device.isAndroidIntentCapable()) {
                url = 'intent://' + url + '#Intent;scheme=http;package=' + packageName + ';S.browser_fallback_url=' + encodeURIComponent(androidFallbackInstallUrl) + ';end';
            } else {
                url = (window.location.protocol || 'https:') + '//' + url;
            }
            Debug([
                'buildExternalDeviceUrlForAndroid',
                'client: ' + client,
                'packageName: ' + packageName,
                'baseUrl: ' + baseUrl,
                'androidFallbackBaseUrl: ' + androidFallbackBaseUrl,
                'androidFallbackInstallUrl: ' + androidFallbackInstallUrl,
                'fullUrl: ' + url
            ].join('\n'));

            return url;
        }

        function _getMetadataForAndroidNativePlayer(videoId, onSuccess) {
            VideoConfig.metadataFetchFunction(videoId, (metadata) => {
                api.fire('metadata', metadata);
                if (api.data().inSweden !== undefined && !api.data().inSweden && (metadata.rights && metadata.rights.geoBlockedSweden)) {
                    api.fire('error', {
                        name: ErrorType.GEO_BLOCK_ERROR
                    });

                    return;
                }

                const videoElement = Sizzle('video', api.element())[0];

                api.data()._video = videoElement;

                var videoData = VideoDataBuilder.build(videoId, metadata, api);

                videoData.video.position = VideoAttributes.getStartPosition(videoElement);
                _sendEvent('ready', {
                    videoId: videoData.videoId,
                    externalUi: true
                });
                api.state().loading = false;
                api.state().ready = true;
                onSuccess(videoData);
            },
            (error, data) => {
                if (data) {
                    api.fire('metadata', data);
                }
                api.fire('error', error);
            });
        }

        if (Device.forceAndroidFallbackMode()) {

            var videoData,
                filter = {
                    load: function () {
                        var videoId = Sizzle('video', api.element())[0].getAttribute('data-video-id');
                        api.element().on('click', function () {
                            api.play().catch(() => {
                                /*
                                 * Wrapper API will throw a 'Interrupted by filters' error because
                                 * play() of the play-filter below. The error is expected and can
                                 * be ignored.
                                 */
                            });
                        });

                        _getMetadataForAndroidNativePlayer(videoId, function (metadata) {
                            videoData = metadata;
                            api.state().ready = true;

                            _sendEvent('ready', {
                                videoId: videoId,
                                externalUi: true
                            });
                        });

                        return true;
                    },
                    play: function () {
                        var videoId = Sizzle('video', api.element())[0].getAttribute('data-video-id'),
                            url;

                        if (videoId) {
                            url = _buildExternalDeviceUrlForAndroid(videoData);
                            //Debug('changeVideo android-url: ' + url);
                            window.location = url;

                            return true;
                        }

                        return false;
                    }
                };

            api.filters.push(filter);
        }
    },

    destroy: function (api) {
	    // empty
    }
};



// WEBPACK FOOTER //
// ./src/js/plugins/android-fallback.js